import React, { useEffect, useState } from 'react';
import { Window } from '@progress/kendo-react-dialogs';
import { ITicketProps } from '../../types/Ticket/ITicket';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useGetTenantQuery } from '../../redux/api/BaseApi';
import { isMobile } from 'react-device-detect';
import { SvgIcon } from '@progress/kendo-react-common';
import * as svg from '@progress/kendo-svg-icons';
import { TicketApi } from '../../redux/api/TicketApi';
import { PartialSpinny } from '../Nav/Spinny';
import { AssetApi } from '../../redux/api/AssetApi';
import { useReduxDispatch } from '../../redux/hooks';

interface AddAssetModalProps {

}

const AddAssetModal: React.FC<AddAssetModalProps> = () => {
    const dispatch = useReduxDispatch();
    const { ticketId } = useParams();
    const { data: ticket } = TicketApi.useGetTicketDetailsQuery({ ticketId: Number(ticketId) });
    const [saveTicketAssets, { isLoading: saving }] = TicketApi.useSaveLinkedAssetsMutation();
    const navigate = useNavigate();
    const { data: tenant } = useGetTenantQuery()
    const goBack = () => {
        navigate(-1);
    }

    useEffect(() => {
        //Add event listener for Events that get posted when a Asset is created or edited.
        const messageListener = (e) => {
            console.log('Message Recieved', e.data);
            try {
                if (e.data?.indexOf && e.data?.indexOf('{') === 0) {
                    console.log('JSON Message Recieved', e.data);
                    var messageObj = JSON.parse(e.data);
                    if ('message' in messageObj && messageObj.message === 'asset_created' && 'assetId' in messageObj) {
                        if (messageObj.assetId != '0') {

                            console.log('assetId', messageObj.assetId);
                            //Link the new asset to the ticket
                            saveTicketAssets({ ticketId: ticket.ID, assets: [{ Call_Id: ticket.ID, Asset_Id: messageObj.assetId }], append: true }).unwrap().then(() => {
                                //Clear the searhc asset cache
                                dispatch(AssetApi.util.invalidateTags(["GetAssets"]));
                                navigate('/ticket/' + ticket?.ID + '/assets')
                            });

                        } else {
                            navigate('/ticket/' + ticket?.ID);
                        }
                        //props.userCreated && props.userCreated({ Contact_Id: messageObj.contactId });                        
                    }
                }
            } catch (err) {
                console.error('ouch in window.addEventListener', err);
            }
        };

        var ev = window.addEventListener("message", messageListener, false)
        //console.log('addEventListener added', messageListener);
        return () => { window.removeEventListener("message", messageListener) }
    }, []);

    return (<>
        <Window modal={true} minimizeButton={() => null} className='dashboard cool-window' title={<><SvgIcon size='large' icon={svg.printIcon} className='mr-2' ></SvgIcon>Add Asset </>} onClose={goBack} initialHeight={800} initialWidth={Math.min(1000, window.innerWidth)}>
            {saving && <PartialSpinny />}
            <iframe src={tenant.Tenant_Url + '/Asset_Mgr/Asset.aspx?Origin=AssetPopup&Contact_Id=' + ticket?.Company_Contact.toString()} width="100%" height="100%" />
        </Window>
    </>
    );
};

export default AddAssetModal;